import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

class SearchWidgetForm extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired,
  };

  render() {
    const { children, ...props } = this.props;

    return children(props);
  }
}

export default reduxForm()(SearchWidgetForm);
